import bezier from './bezier';

const DEFAULT_TIMING_FUNCTION = 'ease';

const easings = {
  'linear': [0.00, 0.0, 1.00, 1.0],
  'ease': [0.25, 0.1, 0.25, 1.0], 
  'ease-in': [0.42, 0.0, 1.00, 1.0],
  'ease-out': [0.00, 0.0, 0.58, 1.0],
  'ease-in-out': [0.42, 0.0, 0.58, 1.0]
};

const createEasingFunction = (type) => {
  if (!type) {
    return bezier.apply(null, easings[DEFAULT_TIMING_FUNCTION]);
  }

  if (typeof type === 'string') {
    if (easings[type]) {
      return bezier.apply(null, easings[type]);
    } else {
      throw new Error('unrecognized easing function');
    }
  } else if (Array.isArray(type) && type.length === 4) {
    return bezier.apply(null, type);
  } else {
    throw new Error('unrecognized easing function');
  }
};

export default createEasingFunction;